/* VertificationDoc – only the 5 docs required by backend */
import React from "react";
import { ToolTip } from "../../ToolTip/ToolTip";
import {
  utilityBillContent,
  certificationOfFormationContent,
  determinationLetterContent,
  certificationOfLicenseContent,
  taxReturnsContent,
} from "../../ToolTip/ToolTipData";
import { UploadFile } from "../../../../../components/forms/uploadFile/UploadFile";
import CreateOrganizationcss from "../../CreateOrgMain/CreateOrganization.module.css";
import { StyleSpan } from "./VertificationDoc.styles";

interface VertificationDocProps {
  orgCreationToken: string;

  /* Required docs */
  setUtilityBill: (file: File | null) => void;
  setOrgCOF: (file: File | null) => void;
  setDeterminationLetter: (file: File | null) => void;
  setOrgBusinessLicenses: (file: File | null) => void;
  setOrgTaxReturns: (file: File | null) => void;

  /* The rest are NOT required now – commented */
  // setBeneficiaries?: (file: File | null) => void;                       // ❌ BACKEND NOT USED – commented for now
  // directorsData?: { id: string; name: string; phoneNumber: number }[]; // ❌
  // setDirectorData?: (v: any) => void;                           // ❌
  // trusteeData?: { id: string; name: string; phoneNumber: number }[];   // ❌
  // setTrusteeData?: (v: any) => void;                            // ❌
}

export function VerificationDoc({
  orgCreationToken,
  setUtilityBill,
  setOrgCOF,
  setDeterminationLetter,
  setOrgBusinessLicenses,
  setOrgTaxReturns,
}: /* setBeneficiaries,   */ // ❌ BACKEND NOT USED – commented for now
VertificationDocProps) {
  return (
    <>
      <h2 className={CreateOrganizationcss.sectionHeader}>
        5. Business Verification Documents
      </h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem' }}>
        <div style={{ flex: '1 1 0', minWidth: 260, maxWidth: '48%' }}>
          <UploadFile
            title={
              <StyleSpan>
                Upload Utility Bill <ToolTip toolTipData={utilityBillContent} />
              </StyleSpan>
            }
            required
            fileFor="utility_bill"
            orgCreationToken={orgCreationToken}
            setFile={setUtilityBill}
          />
        </div>
        <div style={{ flex: '1 1 0', minWidth: 260, maxWidth: '48%' }}>
          <UploadFile
            title={
              <StyleSpan>
                Upload Certificate of Formation <ToolTip toolTipData={certificationOfFormationContent} />
              </StyleSpan>
            }
            required
            fileFor="org_certification_of_formation"
            orgCreationToken={orgCreationToken}
            setFile={setOrgCOF}
          />
        </div>
        <div style={{ flex: '1 1 0', minWidth: 260, maxWidth: '48%' }}>
          <UploadFile
            title={
              <StyleSpan>
                Upload Determination Letter <ToolTip toolTipData={determinationLetterContent} />
              </StyleSpan>
            }
            required
            fileFor="org_determination_letter"
            orgCreationToken={orgCreationToken}
            setFile={setDeterminationLetter}
          />
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '2rem' }}>
          <div style={{ flex: '1 1 0', minWidth: 260, maxWidth: '48%' }}>
            <UploadFile
              title={
                <StyleSpan>
                  Upload Certificate of License
                  <span className={CreateOrganizationcss.optional}>(Optional)</span>{' '}
                  <ToolTip toolTipData={certificationOfLicenseContent} />
                </StyleSpan>
              }
              required={false}
              fileFor="org_business_licenses"
              orgCreationToken={orgCreationToken}
              setFile={setOrgBusinessLicenses}
            />
          </div>
          <div style={{ flex: '1 1 0', minWidth: 260, maxWidth: '48%' }}>
            <UploadFile
              title={
                <StyleSpan>
                  Upload Tax Returns
                  <span className={CreateOrganizationcss.optional}>(Optional)</span>{' '}
                  <ToolTip toolTipData={taxReturnsContent} />
                </StyleSpan>
              }
              required={false}
              fileFor="org_tax_returns"
              orgCreationToken={orgCreationToken}
              setFile={setOrgTaxReturns}
            />
          </div>
        </div>
      </div>

      {/* Beneficiaries & board members are not required by backend now */}
    </>
  );
}
